import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'number-7', 'IconNumber7', [["path",{"d":"M8 4h8l-4 16","key":"svg-0"}]]);